import { t } from "../../services/utils";
import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { updateAppTitle } from "../../data/app/app-title-slice";
import {
  GET_STORIES,
  UPDATE_STORY_PRIVACY,
  ARCHIVE_STORY,
  ADD_STORY_COMMENT,
  LIKE_STORY,
  UNLIKE_STORY,
  GET_CLIENTS,
  POST_NEWS,
  UPDATE_STORY,
} from "../../constants/action-types";
import storiesQueryTypes from "../../constants/stories-query-types";
import {
  List,
  AutoSizer,
  WindowScroller,
  CellMeasurer,
  CellMeasurerCache,
} from "react-virtualized";
import { grey800, primary } from "../../constants/colors";
import storyTypes from "../../constants/storyTypes";
import WorkoutStoryViewModel from "./view-models/WorkoutStoryViewModel";
import BaseStoryViewModel from "./view-models/BaseStoryViewModel";
import AssessmentStoryViewModel from "./view-models/AssessmentStoryViewModel";
import PostStoryViewModel from "./view-models/PostStoryViewModel";
import ProgressPhotoStoryViewModel from "./view-models/ProgressPhotoStoryViewModel";
import LinkStoryViewModel from "./view-models/LinkStoryViewModel";
import MealLogStoryViewModel from "./view-models/MealLogStoryViewModel";
import CheckinStoryViewModel from "./view-models/CheckinStoryViewModel";
import { STORY_VIEW_WIDTH } from "../../constants/values";
import Paper from "@material-ui/core/Paper";
import PostNewsView from "./components/PostNewsView";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import EditIcon from "@material-ui/icons/Edit";
import { showLoading, resetLoading } from "react-redux-loading-bar";
import Space from "./components/Space";
import FilterView from "./components/FilterView";
import CMNav from "../../components/CMNav";
import html2canvas from "html2canvas";
import Fab from "@material-ui/core/Fab";
import IconMoon from "../../components/IconMoon";
import NoRecordFound from "../../components/NoRecordFound";
import { useLocation, useNavigate } from "react-router";
export const storyListViewTypes = {
  FOR_NEWS: 1,
  FOR_CLIENT_DIARY: 2,
  FOR_SINGLE_STORY: 3,
};
const cache = new CellMeasurerCache({
  minHeight: 20,
  defaultHeight: 20,
  fixedWidth: true,
  fixedHeight: false,
});
class StoryListView extends React.Component {
  constructor(props) {
    super(props);
    let filter = null;
    if (props.viewType === storyListViewTypes.FOR_NEWS) {
      filter = {
        forAll: false,
        forTrainer: true,
        id: this.props.me.id,
        storyType: "all",
      };
    } else if (props.viewType === storyListViewTypes.FOR_CLIENT_DIARY) {
      filter = {
        storyType: "all",
        forAll: false,
        forTrainer: true,
        id: this.props.me.id,
      };
    } else if (props.viewType === storyListViewTypes.FOR_SINGLE_STORY) {
      filter = {
        storyType: "all",
        forAll: false,
        forTrainer: true,
        id: this.props.me.id,
      };
    }
    this.state = {
      filter: filter,
      rows: null,
      editedComments: {},
      isLoading: true,
      show: false,
      selectedStoryTypes: Object.values(storyTypes),
      allStoryTypes: true,
      viewModels: [],
    };
  }
  componentDidMount = () => {
    if (this.props.viewType === storyListViewTypes.FOR_NEWS) {
      this.props.updateAppTitle(t("news"));
    } else if (this.props.viewType === storyListViewTypes.FOR_CLIENT_DIARY) {
      if (this.props.client === null) {
        this.props.updateAppTitle(t("diary"));
        this.props.getClients();
      } else {
        this.props.updateAppTitle(`${this.props.client.first_name}'s Diary`);
      }
    } else {
      if (!this.props.isModal) {
        this.props.updateAppTitle(t("news"));
      }
    }
    const { location } = this.props;
    if (location?.state?.groupId) {
      const { groupId } = location?.state;
      this.setState({
        groupId,
      });
      const filter = {
        forAll: false,
        forTrainer: false,
        id: groupId,
      };
      this.onFilterChange(filter);
    }
    if (location?.state && location?.state?.groupId === 0) {
      this.setState({
        groupId: 0,
      });
      const filter = {
        forAll: true,
        forTrainer: false,
        id: 0,
      };
      this.onFilterChange(filter);
    }
    this.loadStories(this.props, true);
    window.addEventListener("scroll", this.handleScroll);
  };
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll = () => {
    if (window.scrollY < 200 && this.state.show === true) {
      this.setState({
        show: false,
      });
    } else if (window.scrollY > 200 && this.state.show !== true) {
      this.setState({
        show: true,
      });
    }
  };
  componentWillReceiveProps = (nextProps) => {
    this.loadStories(nextProps, false);
    const oldRequest = this.props.requests;
    const newRequest = nextProps.requests;
    if (
      this.props.viewType === storyListViewTypes.FOR_CLIENT_DIARY &&
      this.props.client === null &&
      nextProps.client !== null
    ) {
      this.props.updateAppTitle(`${nextProps.client.first_name}'s Diary`);
    }
    if (
      oldRequest.postNewsRequest &&
      oldRequest.postNewsRequest.inProcess &&
      !newRequest.postNewsRequest.inProcess &&
      !newRequest.postNewsRequest.failed
    ) {
      this.setState(
        {
          filter: {
            ...this.state.filter,
            forTrainer: true,
            id: this.props.me.id,
          },
          selectedStoryTypes: Object.values(storyTypes),
          allStoryTypes: true,
        },
        () => {
          this.loadStories(nextProps, true);
        },
      );
    }
    if (
      oldRequest.updateStoryRequest &&
      oldRequest.updateStoryRequest.inProcess &&
      !newRequest.updateStoryRequest.inProcess &&
      !newRequest.updateStoryRequest.failed
    ) {
      console.log("should fetch new stories");
      this.loadStories(nextProps, true, true);
      console.log("should scroll to top");
    }
  };
  refresh = () => {
    this.loadStories(this.props);
    this.list.scrollToPosition(0);
  };
  loadStories = (props, fetch, scroll) => {
    if (props.viewType === storyListViewTypes.FOR_NEWS) {
      if (this.state.filter.forAll === true) {
        if (storiesQueryTypes.GET_ALL in props.storyIndex) {
          let storyIds = props.storyIndex[storiesQueryTypes.GET_ALL];
          this.loadRows(props, storyIds);
        }
        if (fetch) {
          props.getStories({
            type: storiesQueryTypes.GET_ALL,
          });
        }
      } else if (this.state.filter.forTrainer) {
        if (
          storiesQueryTypes.FOR_TRAINER in props.storyIndex &&
          this.state.filter.id in
            props.storyIndex[storiesQueryTypes.FOR_TRAINER]
        ) {
          let storyIds =
            props.storyIndex[storiesQueryTypes.FOR_TRAINER][
              this.state.filter.id
            ];
          this.loadRows(props, storyIds);
        }
        if (fetch) {
          props.getStories({
            type: storiesQueryTypes.FOR_TRAINER,
            trainerId: this.state.filter.id,
            myId: this.props.me.id,
          });
        }
      } else {
        if (
          storiesQueryTypes.FOR_GROUP in props.storyIndex &&
          this.state.filter.id in props.storyIndex[storiesQueryTypes.FOR_GROUP]
        ) {
          let storyIds =
            props.storyIndex[storiesQueryTypes.FOR_GROUP][this.state.filter.id];
          this.loadRows(props, storyIds);
        }
        if (fetch) {
          props.getStories({
            type: storiesQueryTypes.FOR_GROUP,
            segmentId: this.state.filter.id,
          });
        }
      }
    } else if (props.viewType === storyListViewTypes.FOR_CLIENT_DIARY) {
      if (
        storiesQueryTypes.FOR_CLIENT in props.storyIndex &&
        props.clientId in props.storyIndex[storiesQueryTypes.FOR_CLIENT]
      ) {
        let storyIds =
          props.storyIndex[storiesQueryTypes.FOR_CLIENT][props.clientId];
        this.loadRows(props, storyIds);
      }
      if (fetch) {
        props.getStories({
          type: storiesQueryTypes.FOR_CLIENT,
          clientId: props.clientId,
        });
      }
    } else {
      if (props.storyId in props.stories) {
        this.loadRows(props, [props.storyId]);
      }
      if (fetch) {
        props.getStories({
          type: storiesQueryTypes.FOR_SINGLE_STORY,
          storyId: props.storyId,
        });
      }
    }
    if (scroll) {
      this.onScrollToTop();
    }
  };
  loadRows = (props, storyIds) => {
    let viewModels = [];
    if (!storyIds) {
      return;
    }
    const { selectedStoryTypes } = this.state;

    // if (this.props.viewType === storyListViewTypes.FOR_CLIENT_DIARY) {
    if (selectedStoryTypes.length > 0) {
      if (selectedStoryTypes.indexOf("all") < 0) {
        let filtered = [];
        // let st = parseInt(this.state.filter.storyType);

        for (let i = 0; i < storyIds.length; i++) {
          if (
            props.stories[storyIds[i]] &&
            selectedStoryTypes.indexOf(props.stories[storyIds[i]].story_type) >=
              0
            // this.props.stories[storyIds[i]].story_type === st
          ) {
            filtered.push(storyIds[i]);
          }
        }
        storyIds = filtered;
      }
    }

    // }

    if (storyIds.length === 0) {
      this.setState(
        {
          rows: [
            {
              type: NoRecordFound,
              props: {
                title: t("noUpdatesFound"),
                subtitle: t("youCanSeeAllYourClientSActivitiesHere"),
                forStories: true,
              },
              key: `nnv`,
            },
          ],
        },
        () => {
          this.setState({
            isLoading: false,
          });
          this.list.recomputeRowHeights(0);
          cache.clearAll();
          setTimeout(() => {
            if (this.refs.windowScroller) {
              this.refs.windowScroller.updatePosition();
            }
          }, 0);
        },
      );
      return;
    }
    let partsArr = [];
    for (let i = 0; i < storyIds.length; i++) {
      let story = props.stories[storyIds[i]];
      if (story) {
        if (!BaseStoryViewModel.canUnderstand(story)) {
          continue;
        }
        let vm;
        switch (story.story_type) {
          case storyTypes.WORKOUT_LOG: {
            vm = new WorkoutStoryViewModel(
              story,
              this.props.me,
              this.props.viewType,
              this.props.isModal,
            );
            break;
          }
          case storyTypes.ASSESSMENT: {
            vm = new AssessmentStoryViewModel(
              story,
              this.props.me,
              this.props.viewType,
            );
            break;
          }
          case storyTypes.POST: {
            vm = new PostStoryViewModel(
              story,
              this.props.me,
              this.props.viewType,
            );
            break;
          }
          case storyTypes.PROGRESS_PHOTO: {
            vm = new ProgressPhotoStoryViewModel(
              story,
              this.props.me,
              this.props.viewType,
            );
            break;
          }
          case storyTypes.LINK: {
            vm = new LinkStoryViewModel(
              story,
              this.props.me,
              this.props.viewType,
            );
            break;
          }
          case storyTypes.MEAL_LOG: {
            vm = new MealLogStoryViewModel(
              story,
              this.props.me,
              this.props.viewType,
              this.props.isModal,
            );
            break;
          }
          case storyTypes.CHECKIN: {
            vm = new CheckinStoryViewModel(
              story,
              this.props.me,
              this.props.viewType,
            );
            break;
          }
        }
        viewModels.push(vm);
        partsArr.push(vm.getPartsViewModel(this));

        // if(story.story_type == storyTypes.POST) {
        //   partsArr.push(vm.getPartsViewModel(this));
        // }
      }
    }

    let rows = [].concat.apply([], partsArr);
    if (rows.length > 0) {
      rows.push({
        type: Space,
        props: {
          paddingBottom: 50,
        },
        key: `margin-bottom`,
      });
    }
    this.setState({
      rows: rows,
      isLoading: false,
      viewModels,
    });
    // this.list.recomputeRowHeights(0);
    cache.clearAll();
    setTimeout(() => {
      if (this.refs.windowScroller) {
        this.refs.windowScroller.updatePosition();
      }
    }, 0);
  };
  onFilterChange = (filter) => {
    this.setState(
      {
        filter: {
          ...filter,
          storyType: this.state.filter.storyType,
        },
      },
      () => {
        this.loadStories(this.props, true);
        this.list.scrollToPosition(0);
      },
    );
  };
  onStoryTypeFilterChange = (e) => {
    const tempArr = [...this.state.selectedStoryTypes];
    const val = parseInt(e.target.value);
    if (this.state.selectedStoryTypes.indexOf(val) === -1) {
      tempArr.push(val);
    } else {
      const position = this.state.selectedStoryTypes.indexOf(val);
      tempArr.splice(position, 1);
    }
    this.setState(
      {
        // filter: {
        //   ...this.state.filter,
        //   storyType: val
        // },
        selectedStoryTypes: tempArr,
        allStoryTypes: tempArr.length === 6,
      },
      () => {
        this.loadStories(this.props, false);
        this.list.scrollToPosition(0);
      },
    );
  };
  handleAllStoryTypes = (e) => {
    if (this.state.allStoryTypes) {
      this.setState(
        {
          selectedStoryTypes: [],
          allStoryTypes: false,
        },
        () => {
          this.loadStories(this.props, false);
          this.list.scrollToPosition(0);
        },
      );
    } else {
      this.setState(
        {
          selectedStoryTypes: Object.values(storyTypes),
          allStoryTypes: true,
        },
        () => {
          this.loadStories(this.props, false);
          this.list.scrollToPosition(0);
        },
      );
    }
  };
  makeStoryPrivate = (storyId) => {
    this.props.updateStoryPrivacy(storyId, false);
  };
  makeStoryPublic = (storyId) => {
    this.props.updateStoryPrivacy(storyId, true);
  };
  unpinStory = (storyId) => {
    this.props.updateStory(storyId, {
      pinned: false,
    });
  };
  pinStory = (storyId) => {
    this.props.updateStory(storyId, {
      pinned: true,
    });
  };
  likeStory = (storyId) => {
    this.props.likeStory({
      storyId: storyId,
      firstName: this.props.me.first_name,
      userId: this.props.me.id,
    });
  };
  unlikeStory = (storyId) => {
    this.props.unlikeStory({
      storyId: storyId,
      firstName: this.props.me.first_name,
      userId: this.props.me.id,
    });
  };
  archiveStory = (storyId) => {
    this.props.archiveStory(storyId);
  };
  onShare = (storyId) => {
    let storyViewModelIndex = -1;
    let storyViewModel;
    storyViewModelIndex = this.state.viewModels.findIndex(
      (model) => model.story.story_id === storyId,
    );
    storyViewModel = this.state.viewModels[storyViewModelIndex];
    let parts = storyViewModel.getPartsViewModel(this);
    let partelements = parts.map((part) => {
      let props = {
        key: part.key,
        ...part.props,
      };
      let elem = React.createElement(
        "div",
        {
          style: {
            height: "100%",
            width: 800,
            maxWidth: 800,
            marginLeft: "auto",
            marginRight: "auto",
          },
        },
        [React.createElement(part.type, props)],
      );
      return React.createElement(
        "div",
        {
          key: part.key,
        },
        elem,
      );
    });
    let wrapperElement = React.createElement(
      "div",
      {
        style: {
          height: "100%",
          width: 800,
          maxWidth: 800,
          marginLeft: "auto",
          marginRight: "auto",
        },
      },
      [partelements],
    );

    // console.log("part elements are", partelements);
    // console.log(
    //   "element is",
    //   document.getElementsByClassName("flex-container")[0]
    // );
    // // console.log(
    // //   "wrapper is",
    // //   ReactDOM.render(wrapperElement, document.getElementById("screenShot"))
    // // );
    // // ReactDOM.render(wrapperElement, document.getElementById("screenShot"));
    // setTimeout(() => {
    //   html2canvas(document.getElementsByClassName("new-container")[0], {
    //     useCORS: true
    //   }).then(canvas => {
    //     console.log("canvas is", canvas);
    //     // var base64image = canvas.toDataURL("image/png");
    //     // window.open(base64image, "_blank");
    //     // console.log("canvas is", canvas.toDataURL("image/png"));
    //     this.saveAs(canvas.toDataURL("image/png"), "file-name.png");
    //   });
    // }, 2000);
  };

  saveAs = (uri, filename) => {
    var link = document.createElement("a");
    if (typeof link.download === "string") {
      link.href = uri;
      link.download = filename;

      //Firefox requires the link to be in the body
      document.body.appendChild(link);

      //simulate click
      link.click();

      //remove the link when done
      document.body.removeChild(link);
    } else {
      window.open(uri);
    }
  };
  editingComment = (storyId, comment) => {
    let editedComments = {
      ...this.state.editedComments,
    };
    if (comment.length === 0) {
      delete editedComments[BaseStoryViewModel.getAddCommentViewKey(storyId)];
    } else {
      editedComments[BaseStoryViewModel.getAddCommentViewKey(storyId)] =
        comment;
    }
    this.setState({
      editedComments: editedComments,
    });
    // this.list.recomputeRowHeights(0);
    cache.clearAll();
  };
  addStoryComment = (storyId, comment, index) => {
    this.props.addStoryComment(storyId, this.props.me, comment);
    this.setState({
      commentIndex: index,
    });
    setTimeout(() => {
      this.toggleComments(storyId, true, index);
      window.scrollBy(0, 1);
    }, 0);
  };
  toggleComments = (storyId, value, index) => {
    BaseStoryViewModel.setCommentsExpanded(storyId, value);
    this.list.recomputeRowHeights(index);
    cache.clear(index);
  };
  getRowHeight = ({ index }) => {
    let row = this.state.rows[index];
    let t = row.type;
    let props = this.getPropsForIndex(index);
    return t.getHeight(props);
  };
  getPropsForIndex = (index) => {
    let row = this.state.rows[index];
    let props = {
      key: row.key,
      ...row.props,
      index: index,
    };
    if (row.key in this.state.editedComments) {
      props.editedComment = this.state.editedComments[row.key];
    }
    return props;
  };
  openPostNewsView = () => {
    this.refs.postNews.openModal();
    this.setState({
      openPost: true,
    });
  };
  handlePostNews = (payload) => {
    let trainerId = this.props.me.id;
    this.setState({
      filter: {
        ...this.state.filter,
        forTrainer: true,
        id: this.props.me.id,
      },
      selectedStoryTypes: Object.values(storyTypes),
      allStoryTypes: true,
    });
    this.props.postNews({
      ...payload,
      trainerId,
    });
  };
  loadUserDiary = (clientId) => {
    this.props.loadDiary(clientId, this.props.navigate);
  };
  onScrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  rowRenderer = ({ index, isScrolling, style, key, parent }) => {
    let row = this.state.rows[index];
    let props = this.getPropsForIndex(index);
    let elem = React.createElement(
      "div",
      {
        style: {
          height: "100%",
          width: this.props.isModal
            ? this.props.width
              ? this.props.width
              : 640
            : 800,
          maxWidth: this.props.isModal
            ? this.props.width
              ? this.props.width
              : 640
            : 800,
          marginLeft: "auto",
          marginRight: "auto",
        },
      },
      [React.createElement(row.type, props)],
    );
    // return React.createElement("div", { key: row.key, style: style }, elem);

    return (
      <CellMeasurer
        cache={cache}
        columnIndex={0}
        key={key}
        parent={parent}
        rowIndex={index}
      >
        {({ measure, registerChild }) => (
          // 'style' attribute required to position cell (within parent List)
          <div ref={registerChild} style={style}>
            {elem}
          </div>
        )}
      </CellMeasurer>
    );
  };
  render = () => {
    const { isModal } = this.props;
    let styles = {
      win: {
        width: !isModal && "100vw",
      },
      scene: {
        marginTop: !isModal && 57,
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        overflow: "auto",
      },
      container: {
        display: "flex",
        flex: "1 1 auto",
        width: !isModal && 805,
        maxWidth: 805,
        flexDirection: "column",
        marginLeft: !isModal && "auto",
        marginRight: !isModal && "auto",
        position: "relative",
        paddingLeft: !isModal && 2.5,
        paddingRight: !isModal && 2.5,
        overflow: "hidden",
      },
      stories: {
        marginTop: 0,
        marginBottom: 0,
      },
      filters: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        marginTop: !isModal && 15,
        padding: "0 2.5px",
      },
      toolbar: {
        backgroundColor: "transparent",
        display: this.state.rows === null ? "none" : "block",
        zIndex: 100,
        padding: 0,
      },
      refreshButton: {
        paddingTop: 6,
        paddingBottom: 6,
      },
      refreshButtonLabel: {
        color: grey800,
        textTransform: "none",
        fontSize: 16,
        marginLeft: 10,
      },
      windowScrollerWrapper: {
        flex: "1 1 auto",
        height: "100%",
      },
      scrollTop: {
        height: 35,
        width: 35,
        borderRadius: "50%",
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "1px 2px 2px 0px #d8d8d8",
      },
      extraIcons: {
        position: "fixed",
        right: 50,
        bottom: 100,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 5,
      },
      fab: {
        marginTop: 30,
        marginBottom: 5,
        boxShadow:
          "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
      },
      closeIcon: {
        position: "fixed",
        top: 0,
        marginLeft: -32,
        width: 32,
        height: 32,
        backgroundColor: primary,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        zIndex: 99999,
      },
    };
    const { selectedStoryTypes, allStoryTypes } = this.state;
    return (
      <div style={styles.win}>
        <div className={"flex-container"} style={styles.scene}>
          <div
            className={"new-container"}
            style={{
              display: "flex",
              flex: "1 1 auto",
            }}
          />
          <div style={styles.container}>
            <div style={styles.stories}>
              {!this.state.isLoading &&
                this.props.viewType === storyListViewTypes.FOR_NEWS && (
                  <PostNewsView
                    ref="postNews"
                    groups={this.props.groups}
                    groupId={this.state.groupId}
                    showLoading={this.props.showLoading}
                    resetLoading={this.props.resetLoading}
                    postNews={this.handlePostNews}
                    me={this.props.me}
                  />
                )}

              {/* FILTERS */}
              <div style={styles.filters}>
                {this.props.viewType !==
                  storyListViewTypes.FOR_SINGLE_STORY && (
                  <Paper style={styles.toolbar} elevation={0}>
                    <FilterView
                      onFilterChange={this.onFilterChange}
                      onStoryTypeFilterChange={this.onStoryTypeFilterChange}
                      selectedStoryTypes={selectedStoryTypes}
                      forAll={this.state.filter.forAll}
                      forTrainer={this.state.filter.forTrainer}
                      id={this.state.filter.id}
                      onChange={this.onFilterChange}
                      allStoryTypes={allStoryTypes}
                      handleAllStoryTypes={this.handleAllStoryTypes}
                      viewType={this.props.viewType}
                      storyListViewTypes={storyListViewTypes}
                    />
                  </Paper>
                )}
              </div>
              {/* FILTERS END */}
              <WindowScroller ref="windowScroller">
                {({ height, scrollTop, isScrolling, onChildScroll }) => (
                  <div style={styles.windowScrollerWrapper}>
                    <AutoSizer disableHeight>
                      {({ width }) => (
                        <List
                          autoHeight
                          scrollTop={scrollTop}
                          isScrolling={isScrolling}
                          onScroll={onChildScroll}
                          width={width}
                          height={height}
                          rowCount={
                            this.state.rows === null
                              ? 0
                              : this.state.rows.length
                          }
                          // rowHeight={this.getRowHeight}
                          deferredMeasurementCache={cache}
                          rowHeight={cache.rowHeight}
                          rowRenderer={this.rowRenderer}
                          tabIndex={null}
                          rows={this.state.rows}
                          editedComments={this.state.editedComments}
                          ref={(list) => {
                            this.list = list;
                          }}
                          overscanRowCount={5}
                        />
                      )}
                    </AutoSizer>
                  </div>
                )}
              </WindowScroller>
            </div>
          </div>
          {!this.state.isLoading && isModal && (
            <div style={styles.closeIcon} onClick={this.props.onCloseWorkout}>
              <IconMoon icon="close" color="white" />
            </div>
          )}
          {this.state.show && (
            <div style={styles.extraIcons}>
              <div style={styles.scrollTop} onClick={this.onScrollToTop}>
                <KeyboardArrowUpIcon />
              </div>
              {this.props.viewType === storyListViewTypes.FOR_NEWS && (
                <Fab
                  color="primary"
                  aria-label="Edit"
                  style={styles.fab}
                  onClick={this.openPostNewsView}
                >
                  <EditIcon
                    style={{
                      color: "white",
                    }}
                  />
                </Fab>
              )}
            </div>
          )}
        </div>
        {this.props.viewType === storyListViewTypes.FOR_CLIENT_DIARY && (
          <CMNav clientId={this.props.clientId} />
        )}
      </div>
    );
  };
}
const mapStateToProps = (state, ownProps) => {
  let props = {
    ...ownProps,
    stories: state.stories,
    storyIndex: state.storyIndex,
    me: state.me,
    hasNewStories: state.hasNewStories,
    router: state.router,
    groups: state.groups,
    requests: state.requests,
  };
  if (props.viewType === storyListViewTypes.FOR_CLIENT_DIARY) {
    props.client =
      state.clients !== null
        ? state.clients[ownProps.clientId.toString()]
        : null;
  }
  return props;
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateAppTitle: (title) => {
      dispatch(updateAppTitle(title));
    },
    getStories: (query) => {
      dispatch({
        type: GET_STORIES.REQUEST,
        payload: {
          query,
        },
      });
    },
    updateStoryPrivacy: (storyId, isPublic) => {
      dispatch({
        type: UPDATE_STORY_PRIVACY.REQUEST,
        payload: {
          storyId: storyId,
          isPublic: isPublic,
        },
      });
    },
    updateStory: (storyId, params) => {
      dispatch({
        type: UPDATE_STORY.REQUEST,
        payload: {
          storyId: storyId,
          params: params,
        },
      });
    },
    archiveStory: (storyId) => {
      dispatch({
        type: ARCHIVE_STORY.REQUEST,
        payload: {
          storyId: storyId,
        },
      });
    },
    likeStory: (payload) => {
      dispatch({
        type: LIKE_STORY.REQUEST,
        payload: payload,
      });
    },
    unlikeStory: (payload) => {
      dispatch({
        type: UNLIKE_STORY.REQUEST,
        payload: payload,
      });
    },
    addStoryComment: (storyId, me, comment) => {
      dispatch({
        type: ADD_STORY_COMMENT.REQUEST,
        payload: {
          storyId: storyId,
          userId: me.id,
          firstName: me.first_name,
          photo_id: me.photo_id,
          comment: comment,
        },
      });
    },
    getClients: () => {
      dispatch({
        type: GET_CLIENTS.REQUEST,
      });
    },
    showLoading: () => {
      dispatch(showLoading());
    },
    resetLoading: () => {
      dispatch(resetLoading());
    },
    postNews: (payload) => {
      dispatch({
        type: POST_NEWS.REQUEST,
        payload,
      });
    },
    loadDiary: (clientId, navigate) => {
      navigate(`/clients/${clientId}/diary`);
    },
  };
};

const StoryListViewWithRouter = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  return <StoryListView {...props} location={location} navigate={navigate} />;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StoryListViewWithRouter);
